export function regionEditPrompt(note) {
  const extra = String(note || "").trim();
  const base = "Edit only the brushed region. Leave the rest of the image unchanged.";
  return extra ? `${base} ${extra}` : base;
}

export function fitContain(stageWidth, stageHeight, imageWidth, imageHeight) {
  const sw = Number(stageWidth);
  const sh = Number(stageHeight);
  const iw = Number(imageWidth);
  const ih = Number(imageHeight);
  if (![sw, sh, iw, ih].every((value) => Number.isFinite(value) && value > 0)) return 1;
  return Math.min(sw / iw, sh / ih);
}

export function overlayHasMark(imageData) {
  const data = imageData?.data;
  if (!data) return false;
  for (let index = 3; index < data.length; index += 16) {
    if (data[index] > 12) return true;
  }
  return false;
}
